import { ChatMessage } from "../../../../../fay/Api";

export type AscendingSortedChatMessageList = ChatMessage[] & {
  // This tag is used to ensure that the type is not used directly. The only way to get the type is through the
  // type guard.
  __ascendingSorted: never;
};

export const assertSortedChatMessageList = (
  messages: ChatMessage[],
): messages is AscendingSortedChatMessageList => {
  for (let i = 1; i < messages.length; i++) {
    if (messages[i].sent_at < messages[i - 1].sent_at) {
      return false;
    }
  }
  return true;
};

// messages1 and messages2 should be guaranteed to be sorted in ascending order of sent_at.
// Use assertSortedChatMessageList to ensure this.
export const mergeChatMessageListsLinearly = (
  // region Merge logic
  messages1: AscendingSortedChatMessageList,
  messages2: AscendingSortedChatMessageList,
): AscendingSortedChatMessageList => {
  const mergedMessages: ChatMessage[] = [];
  let i = 0;
  let j = 0;

  if (messages1.length === 0) {
    return messages2;
  }

  if (messages2.length === 0) {
    return messages1;
  }

  while (i < messages1.length && j < messages2.length) {
    if (messages1[i].sent_at < messages2[j].sent_at) {
      mergedMessages.push(messages1[i]);
      i++;
    } else if (messages1[i].sent_at > messages2[j].sent_at) {
      mergedMessages.push(messages2[j]);
      j++;
    } else {
      // What if they're the same? Check if they're different message IDs...
      if (messages1[i].message_id !== messages2[j].message_id) {
        // They're different? Add them both!
        mergedMessages.push(messages1[i]);
        mergedMessages.push(messages2[j]);
      } else {
        // They're the same? Just add one of them.
        mergedMessages.push(messages1[i]);
      }
      i++;
      j++;
    }
  }

  while (i < messages1.length) {
    mergedMessages.push(messages1[i]);
    i++;
  }

  while (j < messages2.length) {
    mergedMessages.push(messages2[j]);
    j++;
  }

  return mergedMessages as AscendingSortedChatMessageList;
}; //endregion
